<template>
  <template v-if="label">
    <slot name="label">
      <SrcInputLabel :for="inputId">{{ label }}</SrcInputLabel>
    </slot>
  </template>
  <div class="w-full" :class="[label ? 'mt-1' : '', error ? 'mb-1' : 'mb-4']">
    <textarea
      class="h-24 block w-full px-3 py-2 rounded-lg 
        font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
        border-2 border-skin-b-list-bord 
        hover:bg-skin-b-list-head
        focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0" 
      :id="inputId"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :focus="focus"
      @input="handleInput"
      @keyup="validate"
      @keydown="preventEnter"
      v-bind="$attrs"
      :class="{
        'border-2 border-red-300 bg-red-50 hover:bg-red-50 focus:border-red-300 focus:bg-red-50': error,
      }"
    ></textarea>
    <p v-if="error" class="mt-1 text-xs text-red-600 text-right" role="alert" aria-live="assertive">
      {{ error }}
    </p>
  </div>
</template>

<script>
import SrcInputLabel from '../sources/SrcInputLabel.vue';
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
  components: {
    SrcInputLabel,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    focus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validator_off: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputId: `Textarea-${Math.random().toString(36).substring(7)}`,
      error: '',
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.validate();
      },
    },
    validator_off: {
      immediate: true,
      handler() {
        this.validate();
      },
    },
  },
  methods: {
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value);
      this.validate();
    },
    preventEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    },
    validate() {
      if (this.validator_off) {
        this.error = '';
        this.$emit('valid', true);
        return;
      }

      // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailPattern = /^(\s*[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}\s*;?)+$/i;
      // Trim, Split und prüfen
      const emails = this.modelValue
        .split(';')
        .map(email => email.trim());
      // Prüfen: jede Email darf nicht leer sein und muss gültig sein
      const allValid = emails.every(email => email !== '' && emailPattern.test(email));

      if (!allValid) {
        this.error = this.$t('setnetwork.noemail'); // Fehlertext
        this.$emit('valid', false);
      } else {
        this.error = '';
        this.$emit('valid', true);
      }
    },
  },
};
</script>

<style scoped>
textarea {
  min-height: 100px;
  resize: vertical;
}
</style>
